import type { IconData } from '@stacksjs/iconify-core'

export const devicesHardDrive: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13 1H3L0 7.5h16z\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 15h16V9H0zm3-1.75a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesHardDrive
